export default defineNuxtPlugin({
    name: 'media',
    dependsOn: [],
    async setup(nuxtApp)
    {
        const store = useMediaStore();

        nuxtApp.vueApp.mixin({
            computed: {
                mq: () => store.mq,
                phone: () => store.phone,
                tablet: () => store.tablet,
                mobile: () => store.mobile,
                laptop: () => store.laptop,
                desktop: () => store.desktop
            }
        });
    },
    hooks: {
        'app:mounted'()
        {
            const store = useMediaStore();

            store.setWidth(window.innerWidth);
            window.addEventListener('resize', () =>
            {
                store.setWidth(window.innerWidth);
            });
        }
    }
});

declare module '@vue/runtime-core'
{
    interface ComponentCustomProperties
    {
        mq: string;
        phone: boolean;
        tablet: boolean;
        mobile: boolean;
        laptop: boolean;
        desktop: boolean;
    }
}
